import React, {Component} from 'react';
import {FavCard, CardLeft, Image, CardRight, Description, Content, RemoveFavs, BizTitle, UnfavImg} from '../styles/journey_styles';

export default class FavoriteCard extends Component {
  constructor(props){
    super(props);
    this.state = {
      desc: props.data.desc,
      entity_id: props.data.entity_id,
      business_type: props.data.business_type,
      name: props.data.name,
      lat: props.data.latitude,
      lng: props.data.longitude,
      img_url: props.data.img_url
    }
    this.onConfirm = this.onConfirm.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.unfavClicked = this.unfavClicked.bind(this)
  }

  onConfirm(){
    const entity_id = this.state.entity_id
    const business_type = this.state.business_type
    const name = this.state.name
    const lat = this.state.lat
    const lng = this.state.lng
    const img_url = this.state.img_url
    const desc = this.state.desc
    this.props.updateFavorites(entity_id, name, lat, lng, business_type, img_url, desc)
  }

  onCancel(){
    console.log("cancelled removal from favorites")
  }

  unfavClicked(){
    const favName = this.state.name
    window.confirm('Are you sure you wish to delete ' + favName + ' from your favorites list?') ? this.onConfirm() : this.onCancel()
  }

  render(){
    const unfavoriteImg = require("../images/remove_fav.png")
    const each_desc = this.props.renderRevSummary(this.state.desc)
    return(
      <FavCard>
        <CardLeft>
          <Image src={this.props.data.img_url}/>
        </CardLeft>
        <CardRight>
          <Content>
            <BizTitle> {this.props.data.name} </BizTitle>
            <Description>
              {each_desc}
            </Description>
          </Content>
          <RemoveFavs onClick={this.unfavClicked}><UnfavImg src={ unfavoriteImg} alt="trash it"/> </RemoveFavs>
        </CardRight>
      </FavCard>
      )
    }
  }


// onClick={props.onClick(props.name)}
